// User-facing toast texts. Edit a text here to change it everywhere it is used.
export const toastMessage = {
  COMMON: {
    businessHoursWereCorrectlyUpdated: 'Business hours were correctly updated',
    confirmPasswordMismatch: 'Confirm Password and New Password do not match',
    downloadComplete: 'Download complete!',
    exportFailed: 'Export failed',
    failedToCheckContractorTin: 'Failed to check contractor TIN',
    failedToCheckTheNumber: 'Failed to check the number',
    failedToCreateAgreement: 'Failed to create agreement',
    failedToCreateLocation: 'Failed to create location',
    failedToCreateNote: 'Failed to create note',
    failedToEditTable: 'Failed to edit table',
    failedToFormatDate: 'Failed to format date',
    failedToLoadAgreement: 'Failed to load agreement',
    failedToLoadContact: 'Failed to load contact',
    failedToLoadContractorCloseoutStatus:
      'Failed to load contractor closeout status',
    failedToLoadMemberDetails: 'Failed to load member details',
    failedToLoadNote: 'Failed to load note',
    failedToLoadRide: 'Failed to load ride',
    failedToLoadTableData: 'Failed to load table data',
    failedToUpdateAccess: 'Failed to update access',
    failedToUpdateAgreement: 'Failed to update agreement',
    failedToUpdateNote: 'Failed to update note',
    failedToValidatePhoneNumber: 'Failed to validate phone number',
    fileSizeTooLarge: 'File size must be less than 1.5 MB',
    itsNotAValidNumber: "It's not a valid number",
    locationCreatedSuccessfully: 'Location created successfully.',
    noPermissionToCreateLocation:
      'You do not have permission to create location',
    passwordChangedSuccessfully: 'Password changed successfully',
    passwordDoesNotMeetAllRequirements:
      'Password does not meet all requirements',
    selectStartAndEndDates: 'Please select both start and end dates',
    unableToSaveSegmentEquipment: 'Unable to save segment equipment.',
  },
  ACCOUNT: {
    failedToLoadMoreActivity: 'Failed to load more activity',
    failedToSaveAccountSettings: 'Failed to save account settings',
    profileImageUpdated: 'Profile image updated',
  },
  ADMIN: {
    anErrorOccurred: 'An error occurred',
    emailInvalidOrNotRegistered:
      'The email is invalid or not registered in the system.',
    failedToCreateSurveyTemplate: 'Failed to create survey template',
    failedToCreateUser: 'Failed to create user',
    failedToUnlockUser: 'Failed to unlock user',
    failedToUpdateRolePermission: 'Failed to update role permission',
    failedToUpdateSurveyTemplate: 'Failed to update survey template',
    failedToUpdateUser: 'Failed to update user',
    surveyTemplateUpdatedSuccessfully: 'Survey template updated successfully!',
  },
  ASSIGNMENT: {
    downloadFailed: 'Download failed',
    failedToClaimRides: 'Failed to claim rides.',
    failedToLoadRidesForTransmit: 'Failed to load rides for transmit',
    failedToLockAssignment: 'Failed to lock assignment',
    failedToRejectRides: 'Failed to reject rides.',
    failedToTransmitAssignment: 'Failed to transmit assignment',
    failedToUnlockAllContractors: 'Failed to unlock all contractors.',
    failedToUnlockContractor: 'Failed to unlock contractor',
    failedToUnlockRideSegment: 'Failed to unlock ride segment',
    failedToUnlockRideSegments: 'Failed to unlock ride segments',
    payerNotAcceptingAssignments:
      'This payer is not accepting additional assignments.',
    unlockAssignmentsBeforeRejecting:
      'Unlock assignments for this payer before rejecting rides.',
  },
  AUTH: {
    accountLockedTooManyAttempts:
      'Your account has been locked due to too many failed attempts. Please contact your administrator.',
    failedToCreatePassword: 'Failed to create password. Please try again.',
    failedToReset: 'Failed to reset',
    failedToSendVerificationCode:
      'Failed to send verification code. Please try again.',
    incorrectVerificationCode:
      'The verification code you entered is incorrect.',
    invalidEmailOrPassword:
      'Login Failed: The email or password you entered does not match our records.',
    loginFailed: 'Login failed',
    noAccountLinkedToApple: 'No account is linked to this Apple account.',
    noAccountLinkedToGoogle: 'No account is linked to this Google account.',
    noAccountLinkedToMicrosoft:
      'No account is linked to this Microsoft account.',
    passwordCreatedSuccessfully: 'Password created successfully!',
    passwordsDoNotMatch: 'Passwords do not match',
    pleaseEnterAValidEmailAddress: 'Please enter a valid email address',
    unableToResendCode: 'Unable to send another code right now.',
    verificationCodeResent: 'A new verification code has been sent.',
  },
  CONTACT: {
    contactInfoWasSavedSuccessfully: 'Contact info was saved successfully !',
    contactStatusWasUpdatedSuccessfully:
      'Contact status was updated successfully',
    failedToAttachContact: 'Failed to attach contact',
    failedToCreateContact: 'Failed to create contact',
    failedToReloadContacts: 'Failed to reload contacts',
    failedToRemoveContact: 'Failed to remove contact',
    failedToUpdateContact: 'Failed to update contact',
    failedToUpdateContactStatus: 'Failed to update contact status',
    maxAdditionalContactsReached: 'You can add up to 2 additional contacts.',
  },
  CONTRACTOR: {
    contractorInfoWasUpdatedSuccessfully:
      'Contractor info was updated successfully',
    coverageAreaInfoChangedSuccessfully:
      'Coverage area info changed successfully',
    failedToAcceptInvitation: 'Failed to accept invitation',
    failedToCreateBusinessOwnership: 'Failed to create business ownership',
    failedToCreateCompanyLicense: 'Failed to create company license',
    failedToCreateLiabilityInsurance: 'Failed to create liability insurance',
    failedToCreatePersonnel: 'Failed to create personnel',
    failedToCreateServiceDate: 'Failed to create service date',
    failedToCreateVehicle: 'Failed to create vehicle',
    failedToCreateVehicleInspection: 'Failed to create vehicle inspection',
    failedToCreateVehiclePermit: 'Failed to create vehicle permit',
    failedToCreateVehicleRegistration: 'Failed to create vehicle registration',
    failedToCropTheLogo: 'Failed to crop the logo',
    failedToDeclineInvitation: 'Failed to decline invitation',
    failedToFinishCreatingContractor: 'Failed to finish creating contractor',
    failedToLoadBusinessOwnership: 'Failed to load business ownership',
    failedToLoadCompanyLicense: 'Failed to load company license',
    failedToLoadContractorDetails: 'Failed to load contractor details',
    failedToLoadContractorOperations: 'Failed to load contractor operations',
    failedToLoadCoverageArea: 'Failed to load coverage area',
    failedToLoadLevelsOfService: 'Failed to load levels of service',
    failedToLoadLiabilityInsurance: 'Failed to load liability insurance',
    failedToLoadPersonnel: 'Failed to load personnel',
    failedToLoadServiceDate: 'Failed to load service date',
    failedToLoadVehicleInspection: 'Failed to load vehicle inspection',
    failedToLoadVehiclePermit: 'Failed to load vehicle permit',
    failedToLoadVehicleRegistration: 'Failed to load vehicle registration',
    failedToLoadVehicles: 'Failed to load vehicles',
    failedToUpdateBusinessOwnership: 'Failed to update business ownership',
    failedToUpdateCompanyLicense: 'Failed to update company license',
    failedToUpdateContractorInfo: 'Failed to update contractor info',
    failedToUpdateCoverageArea: 'Failed to update coverage area',
    failedToUpdateLiabilityInsurance: 'Failed to update liability insurance',
    failedToUpdatePersonnel: 'Failed to update personnel',
    failedToUpdateServiceDate: 'Failed to update service date',
    failedToUpdateVehicle: 'Failed to update vehicle',
    failedToUpdateVehicleInspection: 'Failed to update vehicle inspection',
    failedToUpdateVehiclePermit: 'Failed to update vehicle permit',
    failedToUpdateVehiclePictures: 'Failed to update vehicle pictures',
    failedToUpdateVehicleRegistration: 'Failed to update vehicle registration',
    failedToUploadVehiclePictures: 'Failed to upload vehicle pictures',
    invalidContractorTin:
      'Contractor data contains an invalid Tax Identification Number. It must contain exactly 9 digits.',
    invalidLogoFileType: 'Logo must be a PNG, JPG, or SVG file',
    invitationAccepted: 'Invitation accepted',
    invitationDeclined: 'Invitation declined',
    logoFileTooLarge: 'Logo file size must be 5 MB or less',
    npiAlreadyExists:
      'A contractor with this NPI already exists under this payer. Enter a different NPI to continue',
  },
  MEMBER: {
    failedToCreateBenefitLimitation: 'Failed to create benefit limitation',
    failedToCreateLimitation: 'Failed to create limitation',
    failedToCreateMember: 'Failed to create member',
    failedToCreatePhysicianCertification:
      'Failed to create physician certification',
    failedToCreatePreference: 'Failed to create preference',
    failedToCreateServiceAuthorization:
      'Failed to create service authorization',
    failedToCreateSurvey: 'Failed to create survey',
    failedToCreateTransaction: 'Failed to create transaction',
    failedToLoadAuthorizedContact: 'Failed to load authorized contact',
    failedToLoadBenefitLimitation: 'Failed to load benefit limitation',
    failedToLoadLimitation: 'Failed to load limitation',
    failedToLoadPhysicianCertification:
      'Failed to load physician certification',
    failedToLoadPreferredContractor: 'Failed to load preferred contractor',
    failedToLoadServiceAuthorization: 'Failed to load service authorization',
    failedToLoadServices: 'Failed to load services',
    failedToLoadSurvey: 'Failed to load survey',
    failedToLoadTransaction: 'Failed to load transaction',
    failedToLoadTransactions: 'Failed to load transactions',
    failedToSearchMembers: 'Failed to search members',
    failedToUpdateBenefitLimitation: 'Failed to update benefit limitation',
    failedToUpdateLimitation: 'Failed to update limitation',
    failedToUpdateMemberInfo: 'Failed to update member info',
    failedToUpdatePhysicianCertification:
      'Failed to update physician certification',
    failedToUpdatePreference: 'Failed to update preference',
    failedToUpdateServiceAuthorization:
      'Failed to update service authorization',
    failedToUpdateSurvey: 'Failed to update survey',
    failedToUpdateTransaction: 'Failed to update transaction',
    imageUploadFailed: 'Image upload failed',
    memberCreatedSuccessfully: 'Member created successfully !',
    memberIdIsMissing: 'Member ID is missing',
    memberInfoWasUpdatedSuccessfully: 'Member info was updated successfully!',
    memberInfoWasUpdatedSuccessfully2: 'Member info was updated successfully !',
  },
  MONITORING: {
    failedToDownloadFile: 'Failed to download file.',
  },
  NOTIFICATION: {
    failedToClearNotifications: 'Failed to clear notifications',
    failedToMarkNotificationAsRead: 'Failed to mark notification as read',
  },
  PAYER: {
    failedToCreateLevelOfService: 'Failed to create level of service',
    failedToCreateRate: 'Failed to create rate',
    failedToCreateServiceType: 'Failed to create service type',
    failedToLoadAccessData: 'Failed to load access data',
    failedToLoadLevelOfService: 'Failed to load level of service',
    failedToLoadLevelOfServiceOptions:
      'Failed to load level of service options',
    failedToLoadModesOfTransport: 'Failed to load modes of transport',
    failedToLoadPayorDetails: 'Failed to load payor details',
    failedToLoadRate: 'Failed to load rate',
    failedToLoadServiceType: 'Failed to load service type',
    failedToLoadServiceTypes: 'Failed to load service types',
    failedToUpdateInAppScheduling: 'Failed to update In-App Scheduling',
    failedToUpdateLevelOfService: 'Failed to update level of service',
    failedToUpdateMemberMobileApp: 'Failed to update Member Mobile App',
    failedToUpdateOnTimePerformance:
      'Failed to update on-time performance rules',
    failedToUpdateRate: 'Failed to update rate',
    failedToUpdateRideLimit: 'Failed to update ride limit',
    failedToUpdateServiceType: 'Failed to update service type',
    payorInfoWasUpdatedSuccessfully: 'Payor info was updated successfully !',
  },
  PLACE: {
    addressNotFoundAtPin: 'Could not find an address at the new pin position.',
    failedToLoadLocationDetails: 'Failed to load location details',
    failedToLoadPlaceDetails: 'Failed to load place details',
    failedToLoadPlaceServices: 'Failed to load place services',
    failedToSaveLocation: 'Failed to save location',
    failedToUpdateLocation: 'Failed to update location',
    placeInfoWasUpdatedSuccessfully: 'Place info was updated successfully:',
  },
  RIDE: {
    activationTimePassed:
      'The time has passed. Please reopen the modal to activate.',
    cannotCreateStandingOrderForInactiveMember:
      'Cannot create standing order for inactive member.',
    cannotModifySegmentsInPast:
      'Cannot add or modify segments: The requested date is in the past.',
    cannotSaveRideForInactiveMember: 'Cannot save ride for inactive member.',
    editPermissionNotGranted:
      'The system could not grant you edit permission for this ride. Please try again.',
    eligibilityTransactionsPeriodHasExpired:
      'Eligibility transactions period has expired.',
    failedToActivateRide: 'Failed to activate ride.',
    failedToAddStop: 'Failed to add stop. Please try again.',
    failedToCancelRideSegment: 'Failed to cancel ride segment',
    failedToCancelRideSegment2: 'Failed to cancel ride segment.',
    failedToCreateRide: 'Failed to create ride',
    failedToCreateStandingOrder: 'Failed to create standing order',
    failedToLoadGeneratedRides:
      'Something went wrong while loading generated rides.',
    failedToLoadSegmentLockStatus: 'Failed to load segment lock status',
    failedToLoadSegmentStatuses: 'Failed to load segment statuses',
    failedToLoadStandingOrder: 'Failed to load standing order',
    failedToReactivateRideSegment: 'Failed to reactivate ride segment',
    failedToReleaseSegmentLocks: 'Failed to release segment locks',
    failedToRequestEditPermission: 'Failed to request edit permission',
    failedToReturn: 'Failed to Return. Please try again.',
    failedToSendSms: 'Failed to send SMS',
    failedToUpdateRide: 'Failed to update ride',
    failedToUpdateSegmentStatus: 'Failed to update segment status',
    failedToUpdateStandingOrder: 'Failed to update standing order',
    loadingLobOptions: 'Loading Line of Business options, please wait.',
    losNotAvailableForDate:
      'Level of Service is not available for the selected date. Please choose another date',
    losNotAvailableForLob:
      'The selected Level of Service is not available for this Line of Business/date. Please select a Level of Service.',
    memberAuthorizationNumberIsMissing:
      'Member authorization number is missing',
    missingMemberServiceAuthorizations: 'Missing member service authorizations',
    noEligibilityForDate:
      'No eligibility / Line of Business is available for the selected date. Please select another date or Level of Service.',
    onlyOneSegmentCanBeReactivated: 'Only one segment can be reactivated',
    pickupTimeInPast:
      'Pickup time cannot be in the past. Please update to a current or future time.',
    pleaseSelectTheLineOfBusiness: 'Please select the Line of Business.',
    rideActivated: 'Ride activated.',
    rideInformationSentSuccessfully: 'Ride information sent successfully',
    rideSegmentCanceledSuccessfully: 'Ride segment canceled successfully.',
    rideSegmentWasCancelled: 'Ride segment was cancelled.',
    rideshareCompanyIsNotAvailable: 'rideshare company is not available',
    rideUpdatedSuccessfully: 'Ride updated successfully.',
    rideWasCreatedSuccessfully: 'Ride was created successfully.',
    segmentsHaveUnavailableContractors:
      'One or more segments have unavailable contractors. Please update them before saving.',
    standingOrderUpdatedSuccessfully: 'Standing order updated successfully.',
    standingOrderWasCreatedSuccessfully:
      'Standing order was created successfully.',
    startDateAfterEndDate: "Start date can't be later than end date",
    statusesUpdatedSuccessfully: 'Statuses updated successfully.',
  },
} as const;
